import React from "react";
import styled from "styled-components";

const Container = styled.div`
  height: 14.707px;
  width: 14.707px;

  @media (min-width: 1800px) {
    height: 20.88px;
    width: 20.88px;
  }

  @media (max-width: 575px) {
    height: 15px;
    width: 15px;
  }
`;

const SearchClose = ({ ...props }) => {
  return (
    <Container>
      {/* <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 14.707 14.707"
        height="100%"
        width="100%"
      >
        <g
          transform="translate(.354 .354)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
        >
          <line x1="14" y1="14" />
          <line y1="14" x2="14" />
        </g>
      </svg> */}

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 23.002 23.002"
        height="100%"
        width="100%"
        {...props}
      >
        <g
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="2"
          transform="translate(1.061 1.061)"
        >
          <path d="M20.881 20.881L0 0" />
          <path d="M0 20.881L20.881 0" />
        </g>
      </svg>
    </Container>
  );
};

export default SearchClose;
